/**
 * 菜单模块信息
 */
import { inject, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import useConfirm from './useConfirm'
import type EventBus from '../EventBus'
export default (siteId: string, $bus: EventBus) => {
  const $http = inject('$http') as any

  const addMenuForm = reactive({
    column_title: '',
    parent_id: '',
    site_id: siteId,
    column_type: -1
  })

  const editMenuForm = reactive({
    column_title: '',
    id: '',
    status: 0
  })

  // 添加菜单模块
  const addMenuInfo = async (title: string, parentId: string) => {
    addMenuForm.column_title = title
    addMenuForm.parent_id = parentId
    await $http.addCaseMenu(addMenuForm)
    // 重置
    addMenuForm.column_type = -1
    $bus.emit('updateMenuAndCol')
  }

  // 修改菜单模块
  const updateMenuInfo = async () => {
    await $http.updateCaseMenu(editMenuForm)
    $bus.emit('updateMenuAndCol')
  }

  // 删除菜单模块
  const deleteMenu = async (ids: string) => {
    await useConfirm({
      headerTitle: '提示',
      tipTitle: `确定删除这项内容吗？`,
      tipText: `删除后，将无法恢复初始状态。`
    })
    const res = await $http.delCaseMenu({ site_id: siteId, ids })
    if (res > 0) {
      ElMessage.success('删除成功')
      $bus.emit('updateMenuAndCol')
    }
  }
  return {
    editMenuForm,
    addMenuInfo,
    updateMenuInfo,
    deleteMenu
  }
}
